module.exports = __webpack_public_path__ + "media/images/aa-035082ed80863d32f43fef28c2bfbf79.webp";